import { UdeuRecord } from "./udeu-record";
import { UdeuStatus } from "./udeu-status";

export class UdeuLoan {
    id?: string;
    name?: string;
    status: UdeuStatus;
    data: UdeuData;
    info: UdeuInfo;
    lentRecords: string[] | UdeuRecord[];
    
    constructor(id?: string) {
        this.id = id;
        this.data = new UdeuData();
        this.info = new UdeuInfo();
    }
}


export class UdeuData {
    applicantName: string;
    email: string;
    requestDate: string;
    description: string;
    reason: string;
    lastYearEnrollment: string;
    student: string;
    external: boolean;
    interdepartmental: boolean;
}

export class UdeuInfo {
    observations: string;
    returnDate: string;
    startDate: string;
    endDate: string;
    internalNotes: string;
    renewDate: string;
    renewObservations: string;
    archivist: string;
    center: string;
    method: string;
}